// extracted by mini-css-extract-plugin
export var changeIcon = "_5m-4";
export var container = "_5m-0";
export var divider = "_5m-7";
export var externalLinkIcon = "_5m-1";
export var green = "_5m-5";
export var helpCircleIcon = "_5m-3";
export var iconButton = "_5m-2";
export var red = "_5m-6";